// API
import { replace } from "react-router-redux";
import { _delete, get } from "../../../services/api";
// Router
import { BASE_URL } from "../../../config/constants";
// Ducks
import { hideSpinner, showSpinner } from "../../../services/spinner.ducks";
import {
  setErrorNotification,
  setNotification
} from "../../../components/SmartNotification/SmartNotification.ducks";

const SET_BOOKINGS = `SET_BOOKINGS`;
const CLEAR_BOOKINGS = `CLEAR_BOOKINGS`;
const SET_BOOKINGS_ERROR = `SET_BOOKINGS_ERROR`;

const defaultState = {
  bookings: [],
  hasError: false
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case SET_BOOKINGS:
      return { ...state, bookings: action.payload };
    case CLEAR_BOOKINGS:
      return { ...state, bookings: defaultState.bookings };
    case SET_BOOKINGS_ERROR:
      return { ...state, hasError: action.payload };
    default:
      return state;
  }
};

export const clearBookings = () => ({
  type: CLEAR_BOOKINGS
});

const setBookings = (value) => ({
  type: SET_BOOKINGS,
  payload: value
});

const setBookingsError = (value) => ({
  type: SET_BOOKINGS_ERROR,
  payload: value
});

export const getBookings = () => async (dispatch, getState) => {
  const {
    auth: { role },
    users: { selectedCandidate }
  } = getState();
  const isAdmin = role === `admin`;

  const url = isAdmin ? `/admin/booking?userId=${selectedCandidate.id}` : `/booking`;

  try {
    dispatch(showSpinner());
    const response = await dispatch(get(url));
    dispatch(setBookings(response.data));
    dispatch(hideSpinner());
  } catch (error) {
    dispatch(setBookingsError(true));
    dispatch(hideSpinner());
  }
};

export const cancelBooking = (bookingId) => async (dispatch, getState) => {
  const {
    auth: { role },
    users: { selectedCandidate }
  } = getState();
  const isAdmin = role === `admin`;

  const url = isAdmin
    ? `/admin/booking/${bookingId}?userId=${selectedCandidate.id}`
    : `/booking/${bookingId}`;

  try {
    dispatch(showSpinner());
    const response = await dispatch(_delete(url));
    const { issuedRefundVoucher } = response.data;
    dispatch(getBookings());
    dispatch(hideSpinner());
    dispatch(
      setNotification({
        confirmLabel: issuedRefundVoucher
          ? `modules.localization.register.authenticated.smartNotifications.label.viewVouchers`
          : ``,
        confirmAction: issuedRefundVoucher
          ? () => dispatch(replace(`${BASE_URL}/dashboard/vouchers`))
          : undefined,
        messageTranslationKey: issuedRefundVoucher
          ? `modules.localization.register.authenticated.smartNotifications.label.bookingCancellationSuccessfulWithVoucher`
          : `modules.localization.register.authenticated.smartNotifications.bookingCancellationSuccessful`,
        titleTranslationKey: `modules.localization.register.authenticated.smartNotifications.label.cancellationSuccess`,
        type: `success`
      })
    );
  } catch (error) {
    dispatch(getBookings());
    dispatch(hideSpinner());
    const err = error.response && error.response.data && error.response.data.message;

    const errorMessage =
      err === `booking.cancellation.outOfPeriod`
        ? `modules.localization.register.authenticated.smartNotifications.error.bookingCancellation.outOfPeriod`
        : err;

    dispatch(
      setErrorNotification({
        messageTranslationKey:
          errorMessage ||
          `modules.localization.register.anonymous.smartNotifications.error.generic`,
        titleTranslationKey: `modules.localization.register.authenticated.smartNotifications.error.label.cancellationError`
      })
    );
  }
};
